import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Typography } from '@altermaind/web/ui';
import { AlertBadge, RenderLocalesWithComponents } from '@/_shared/components';
import { useDialog } from '@/_shared/hooks';
import { SurveyTemplate } from '../../state';
import { getTemplatesCall } from '../../state/api';
import { SendSurvey } from '../SendSurvey';

type Props = {
  countPeople: number;
  setTrigger?: Dispatch<SetStateAction<boolean>>;
};

export const EmptyStateNoCampaigns: FC<Props> = ({ countPeople, setTrigger }) => {
  const t = useTranslations('surveys.emptyStateNoCampaigns');
  const { isOpen, closeDialog } = useDialog('sendSurvey');

  const { surveyId } = useParams();

  const { openDialog: openDialogSendSurvey } = useDialog('sendSurvey');

  const { response: responseGetTemplates } = getTemplatesCall.hook();

  const isSoftSkill = useMemo(() => {
    return (
      responseGetTemplates &&
      responseGetTemplates.find(template => template.id === surveyId)?.name ===
        SurveyTemplate.SoftSkillAssessment
    );
  }, [responseGetTemplates, surveyId]);

  const templateName = useMemo(() => {
    return responseGetTemplates
      ? responseGetTemplates.find(template => template.id === surveyId)?.name
      : '';
  }, [responseGetTemplates, surveyId]);

  return (
    <>
      <Card data-testid='empty-state-no-campaigns' textAlign='center' bg='transparent' px='none'>
        <Typography variant='h1' mb='s'>
          {templateName}
        </Typography>
        <Typography variant='p3/light' mb='s'>
          <RenderLocalesWithComponents
            text={t('descriptionLine1', {
              send: '!{SEND}!',
              ...{ countPeople, templateName },
            })}
            placeholders={{
              '!{SEND}!': (
                <Typography as='span' variant='p2/light'>
                  {t('ctaLabel')}
                </Typography>
              ),
            }}
          />
        </Typography>
        <Button mx='auto' onClick={() => openDialogSendSurvey()} variant='primary' mt='m'>
          {t('ctaLabel')}
        </Button>
        {isSoftSkill && (
          <Box mt='m' textAlign='left' maxWidth='100%' mx='auto'>
            <AlertBadge iconName='lightBulb' type='primary' label={t('alertBadge')} />
          </Box>
        )}
      </Card>
      <SendSurvey
        setTrigger={setTrigger}
        isOpen={isOpen}
        closeDialog={closeDialog}
        currentTemplateName={templateName}
      />
    </>
  );
};
